export default "__VITE_ASSET__BoYOC1IS__"